import cn from 'classnames/bind';
import * as React from 'react';
import classes from './index.module.scss.js';

const cx = cn.bind(classes);
const InputFooter = ({ message, isError = true, }) => {
    const CustomTag = isError ? 'output' : 'span';
    return (React.createElement("div", { className: cx('cactus-input-footer__wrapper') },
        React.createElement("div", { className: cx('message-wrapper') },
            React.createElement(CustomTag, { className: cx('message', 'size-small', isError ? 'error' : 'info') }, message))));
};

export { InputFooter };
//# sourceMappingURL=index.js.map
